import { ReduxHelper } from "helpers";
import { IBaseReducerState } from "helpers/reduxHelpers";
import { UserActions } from "redux/actions";

interface IUserState extends IBaseReducerState {}

const initialState: IUserState = {
  action: UserActions.prefix,
  prefix: UserActions.prefix,
};

const UserReducer = ReduxHelper.createHandleReducer<IUserState>(
  initialState,
  (builder) => {}
);

export default UserReducer;
